import React, { Fragment, useEffect, useState, useRef } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";

const reviewSchema = Yup.object().shape({
  title: Yup.string().required("Required"),
  name: Yup.string().required("Required"),
  rating: Yup.number().required("Required"),
  message: Yup.string().required("Required"),
  // email: Yup.string().email().required("Required"),
});

const buildFormData = (data, objectName, fileKey) => {

  const formData = new FormData();
  Object.keys(data).map((vKey) => {
    if(vKey != fileKey) {
      formData.append(`${objectName}[${vKey}]`, data[vKey]);
    } else if(data[vKey]) {
      [...data[vKey]].map( (file, idx) => {
        formData.append(`${objectName}[${vKey}][]`, file);
      })
    }
  });
  return formData;
}
const ReviewForm = (props) => {
  const { listing, currentUser } = props;
  const [isLoading, setIsLoading] = useState(false)
  const formRef = useRef();
  const stars = [
    { label: 1, value: 1 },
    { label: 2, value: 2 },
    { label: 3, value: 3 },
    { label: 4, value: 4 },
    { label: 5, value: 5 },
  ];

  const handleSave = (data, {resetForm}) => {
    console.log('save', data, data.images);
    setIsLoading(true);
    fetch(`/listing/${listing.slug}/reviews`, {
      method: 'POST',
      headers: {
        // "Content-Type": "application/json",
        // 'Content-Type': 'multipart/form-data',
        "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]')
        ?.content,
      },
      body: buildFormData(data, 'review', 'images')
    }).then((resp) => {
      return resp.json();
    }).then((resp) => {
      console.log('resp', resp);
      setIsLoading(false);
      if(props.onSubmitted) {
        props.onSubmitted(resp);
      }
      resetForm();
      formRef.current.reset();
    }).catch((error) => {
      console.log('error', error);
      setIsLoading(false);
    })
  }

  const formik = useFormik({
    initialValues: {    
      name: currentUser?.display_name  || ''
    },
    validationSchema: reviewSchema, // replace with your actual validation schema
    onSubmit: handleSave, // replace with your form submission function
  });

  const { values, handleSubmit, handleChange, handleBlur, errors, touched, setFieldValue } =
    formik;
  
    // console.log("error", errors, values);

  return (
    <Fragment>
      <form onSubmit={handleSubmit} ref={formRef}>
        <div id="utf_add_review" className="utf_add_review-box">
          <h3 className="utf_listing_headline_part margin-bottom-20">
            Submit your review
          </h3>
          <span className="utf_leave_rating_title">
            Your email address will not be published. Required fields are marked{" "}
            <sup>*</sup>
          </span>
          <div className="row">
            <div className="col-md-6 col-sm-6 col-xs-12">
              <div className="clearfix"></div>
              <div className="utf_leave_rating margin-bottom-30">
                {
                  stars.map((star) => (
                    <Fragment key={star.value}>
                      <input
                        type="radio"
                        name="rating"
                        id={`rating-${star.label}`}
                        value={`${star.value}`}
                        onClick={e => setFieldValue('rating', Math.min(5, 6-star.value))}
                      />
                      <label htmlFor={`rating-${star.label}`} className="fa fa-star"></label>
                    </Fragment>
                  ))
                }
               
              </div>
              <div className="clearfix"></div>
            </div>
            <div className="col-md-6 col-sm-6 col-xs-12">
              <div className="add-review-photos margin-bottom-30">
                <div className="photoUpload">
                  {" "}
                  <span>
                    Upload Photo <i className="sl sl-icon-arrow-up-circle"></i>
                  </span>
                  <input 
                    type="file" 
                    name="images"
                    className="upload" 
                    multiple
                    accept="image/*"
                    // value={values.images}
                    onChange={e => setFieldValue('images', e.target.files)}
                  />
                </div>
              </div>
            </div>
          </div>
          <div id="utf_add_comment" className="utf_add_comment">
            <fieldset>
              <div className="row">
                <div className="col-md-12">
                  <input
                    type="text"
                    name="title"
                    id="title"
                    placeholder="Title of the review*"
                    autoComplete="review-title"
                    value={`${values.title || ""}`}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    required={true}
                    className={errors.title && touched.title ? " error" : ""}
                  />
                </div>
              </div>
              <div className="row">
                <div className="col-md-12">
                  <input
                    type="text"
                    name="name"
                    id="name"
                    placeholder="Your display name*"
                    autoComplete="name"
                    value={`${values.name || ""}`}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    required={true}
                    className={errors.name && touched.name ? " error" : ""}
                  />
                </div>
                {/* <div className="col-md-6">
                  <input
                    type="text"
                    name="email"
                    id="email"
                    placeholder="Your e-mail address"
                    autoComplete="email"
                    value={`${values.email || ""}`}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    required={true}
                    className={errors.email && touched.email ? " error" : ""}
                  />
                </div> */}
              </div>
              <div>
                <textarea
                  type="text"
                  name="message"
                  id="message"
                  placeholder="Your review*"
                  autoComplete="off"
                  value={`${values.message || ""}`}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  required={true}
                  className={errors.message && touched.message ? " error" : ""}
                  rows="3"
                  cols="40"
                />
              </div>
            </fieldset>
            <button className="button" type="submit" disabled={isLoading}>
              Submit Review
            </button>
            <div className="clearfix"></div>
          </div>
        </div>
      </form>
    </Fragment>
  );
};
export default ReviewForm;
